const isDev = import.meta.env.DEV;

export const logger = {
  info: (message: string, data?: any) => {
    if (isDev) console.log(`[INFO] ${message}`, data);
  },
  error: (message: string, error?: Error | any) => {
    console.error(`[ERROR] ${message}`, error);
    // En production, envoyer à un service de monitoring
    if (!isDev && error) {
      // TODO: Intégrer avec un service de monitoring (Sentry, LogRocket, etc.)
    }
  },
  warn: (message: string, data?: any) => {
    if (isDev) console.warn(`[WARN] ${message}`, data);
  },
  debug: (message: string, data?: any) => {
    if (isDev) console.debug(`[DEBUG] ${message}`, data);
  }
};
